import React, { useState }  from 'react';
import { Spin } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faCreditCard, faQuestionCircle, faUpload, faVideo } from '@fortawesome/free-solid-svg-icons';
import ProcessButton from '../buttons/ProcessButton';
import { getBase64, removeWhitespaceSpeicals, getIdentityPutUrlApi, verifyIdentityApi, videoUploadApi } from '../utils/ApiUtils';

const section4Str = "Your data is never sold to third parties.\nHit.Movie does not serve ads.\nYou can delete your data anytime.";
const frontIDStr = "Govt. Photo ID - Front\n(Max 3 MB)";
const backIDStr = "Govt. Photo ID - Back\n(Max 3 MB)";
const videoStr = "Video Selfie.\n(Max 25MB)";
const videoSubStr = "Hold the ID card just below your face and take video selfie. Each side of your ID card must be visible for atleast 3 seconds";
const yellowColor = '#BD9806', blueColor = '#5A6A7A', redColor = '#FF8888';

let fileFront = null, fileBack = null, fileVideo = null, videoType = '';
let frontName = null, backName = null, videoName = null, uploadCount = 0;

export default function StepTwo(props) {
  
    let inputFront = null, inputBack = null, inputVideo = null;
    const [loader, setLoader] = useState(false);
    const [imageFront, setImageFront] = useState("");
    const [imageBack, setImageBack] = useState("");
    const [imageVideo, setImageVideo] = useState("");
    const [message, setMessage] = useState("You can delete your data anytime.");
    const [errorFront, setErrorFront] = useState("");
    const [errorBack, setErrorBack] = useState("");
    const [errorVideo, setErrorVideo] = useState("");

    const onDocUpload = (e, index) => {
        if(e) {
            let file = e.target.files[0];
            if(file) {
                console.log('file size='+file.size+' fileName='+file.name+' file type='+file.type);
                if(index==1) {
                    if(file.size<3000000&&(file.type=="image/jpeg"||file.type=="image/png")) {
                        getBase64(file, imageUrl => {
                            fileFront = file;
                            frontName = removeWhitespaceSpeicals(file.name);
                            setImageFront(imageUrl);
                        });
                    } else {
                        setErrorFront("Please upload a PNG/JPEG image less than 3MB");
                    }
                } else if(index==2) {
                    if(file.size<3000000&&(file.type=="image/jpeg"||file.type=="image/png")) {
                        getBase64(file, imageUrl => {
                            fileBack = file;
                            backName = removeWhitespaceSpeicals(file.name);
                            setImageBack(imageUrl);
                        });
                    } else {
                        setErrorBack("Please upload a PNG/JPEG image less than 3MB");
                    }
                } else if(index==3) {
                    if(file.size<25000000&&(file.type.includes("video"))) {
                        getBase64(file, imageUrl => {
                            fileVideo = file;
                            videoName = removeWhitespaceSpeicals(file.name);
                            videoType = file.type;
                            let last3Chars = file.name.substr(-3);
                            if(last3Chars=='mov'||last3Chars=='MOV') {
                                videoType = 'video/mov';
                            }
                            console.log('file tyep='+videoType+' last3Chars='+last3Chars);
                            setImageVideo(imageUrl);
                        });
                    } else {
                        setErrorVideo("Please upload a video less than 25MB");
                    }
                } 
            }   
        }
    }

    const uploadDocs = () => {
        console.log('fileFront='+fileFront+' fileBack='+fileBack+' fileVideo='+fileVideo);
        if(fileFront&&fileBack&&fileVideo) {
            setLoader(true);
            let sessionValue = props.sessionValue;
            console.log('calling upload Image here.');
            getIdentityPutUrlApi(sessionValue, frontName, backName, videoName)
            .then(response => {
                console.log('get image url='+JSON.stringify(response));
                let resInfo = response.info;
                if(resInfo) {
                    fileUploadApiCall(sessionValue, resInfo.ID_FRONT, fileFront, "");
                    fileUploadApiCall(sessionValue, resInfo.ID_BACK, fileBack, "");
                    fileUploadApiCall(sessionValue, resInfo.ID_VIDEO, fileVideo, videoType);
                    verifyIdentity(sessionValue, frontName, backName, videoName);
                } else {
                    setMessage('Fetch put url failed. Please try again.');
                    setLoader(false);
                }
          });
        } else {
          setMessage('Please upload Front, Back and Video files.');
        }
    }
    
    const fileUploadApiCall = (sessionValue, uploadUrl, file, videoType) => {
        videoUploadApi(sessionValue, uploadUrl, file, videoType)
          .then(response => {
            console.log('Update business data='+JSON.stringify(response));
            if(response) {
              console.log('file uploaded success.');
              uploadCount++;
            } else {
                setMessage("File uploading failed. Please try again.");
                setLoader(false);
            }
        });
    }

    const verifyIdentity = (sessionValue, frontName, backName, videoName) => {
        console.log('calling verifyIdentity upload count='+uploadCount);
        if(uploadCount>2) {
            console.log('upload success count='+uploadCount);
            verifyIdentityApi(sessionValue, frontName, backName, videoName)
            .then(response => {
                console.log('Update business data='+JSON.stringify(response));
                if(response) {
                    setLoader(false);
                    props.documentUploaded();
                } else {
                    setMessage("Verify identity api failed. Please try again.");
                    setLoader(false);
                }
            });
        } else {
            setTimeout(function() { 
                verifyIdentity(sessionValue, frontName, backName, videoName);                
             }, 1000);
        }
    }

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <FontAwesomeIcon icon={faAddressCard} style={{ color: yellowColor, fontSize: 30, marginTop: 30 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        margin: 30 }}>
            <div style={{ fontSize: 18, fontFamily: 'OpenSans-SemiBold', color: yellowColor, marginBottom: 12 }}>
                UPLOAD DOCUMENTS
            </div>
            <div style={{ fontSize: 14, fontFamily: 'OpenSans-Regular', color: yellowColor, lineHeight: 1.2,
            whiteSpace: 'break-spaces', textAlign: 'center' }}>
                {section4Str}
            </div>
            <div onClick={() => { inputFront.click() }} style={{ width: 280, height: 150, marginTop: 20,
                display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                { imageFront
                ?
                <img src={imageFront} style={{ maxWidth: 280, maxHeight: 150 }} />
                :
                <IDTile text={frontIDStr} secondIcon={faAddressCard} error={errorFront} />
                }
            <input style={{ display:'none' }} type="file" ref={input => inputFront = input} 
                onChange={(e) => { onDocUpload(e, 1) }} />   
            </div>
            <div onClick={() => { inputBack.click() }} style={{ width: 280, height: 150, marginTop: 20, 
                display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                { imageBack
                ?
                <img src={imageBack} style={{ maxWidth: 280, maxHeight: 150 }} />
                :
                <IDTile text={backIDStr} secondIcon={faCreditCard} error={errorBack} />
                }
                <input style={{ display:'none' }} type="file" ref={input => inputBack = input} 
                onChange={(e) => { onDocUpload(e, 2) }} />   
            </div>
            <div onClick={() => { inputVideo.click() }} style={{ width: 280, height: 170, marginTop: 20, 
                display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
            { imageVideo
                ?
                <video width='280' height='150'>
                    <source src={imageVideo} type="video/mp4"/>
                </video>
                :
                <IDTileVideo text={videoStr} subtext={videoSubStr} error={errorVideo} />
                }
                <input style={{ display:'none' }} type="file" ref={input => inputVideo = input} 
                onChange={(e) => { onDocUpload(e, 3) }} />   
            </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 16 }}>
            <ProcessButton text="Submit" bgColor={yellowColor} onClick={() => uploadDocs()} />
            <div onClick={()=> window.open("https://docs.hit.movie/identity-verification", "_blank")} 
            style={{ position: 'absolute', marginLeft: 220, marginTop: 10, cursor: 'pointer' }}>
                <FontAwesomeIcon icon={faQuestionCircle} style={{ color: props.yellowColor, fontSize: 20 }} />
            </div>
        </div>
        <div style={{ fontSize: 10, fontFamily: 'OpenSans-SemiBold', color: redColor, textAlign: 'center', marginTop: 6 }}>
            {message}
        </div>
        { loader &&
            <div style={{ position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center',
            top: 0, left: 0, width: '100%', height: '100%', zIndex: 11, backgroundColor: 'rgba(10, 26, 42, 0.6)' }}>
                <Spin size='large' />
            </div>
        }
      </div>
    );
}
function IDTile(props) {
    return (
        <div style={{ width: 280, height: 150, backgroundColor: '#E5E5E5', 
        textAlign: 'center', cursor: 'pointer' }}>
            <FontAwesomeIcon icon={faUpload} style={{ color: blueColor, fontSize: 20, marginTop: 24 }} />
            <div style={{ whiteSpace: 'break-spaces', color: blueColor, fontSize: 13, 
            fontFamily: 'OpenSans-SemiBold', marginTop: 12, lineHeight: 1.1 }}>
                {props.text}
            </div>
            <div style={{ position: 'absolute', width: 280, fontSize: 10, 
            fontFamily: 'OpenSans-SemiBold', color: redColor, textAlign: 'center' }}>
                {props.error}
            </div>
            <FontAwesomeIcon icon={props.secondIcon} style={{ color: blueColor, fontSize: 20, marginTop: 18 }} />
        </div>
    );
}

function IDTileVideo(props) {
    return (
        <div style={{ width: 280, height: 170, backgroundColor: '#E5E5E5', 
        textAlign: 'center', cursor: 'pointer', padding: 12 }}>
            <FontAwesomeIcon icon={faUpload} style={{ color: blueColor, fontSize: 20 }} />
            <div style={{ whiteSpace: 'break-spaces', color: blueColor, fontSize: 13, 
            fontFamily: 'OpenSans-SemiBold', marginTop: 8, lineHeight: 1.1 }}>
                {props.text}
            </div>
            <div style={{ whiteSpace: 'break-spaces', color: blueColor, fontSize: 11,
            fontFamily: 'OpenSans-SemiBold', marginTop: 4, lineHeight: 1.1 }}>
                {props.subtext}
            </div>
            <div style={{ position: 'absolute', width: 280, fontSize: 10, 
            fontFamily: 'OpenSans-SemiBold', color: redColor, textAlign: 'center' }}>
                {props.error}
            </div>
            <FontAwesomeIcon icon={faVideo} style={{ color: blueColor, fontSize: 20, marginTop: 18 }} />
        </div>
    );
}